module.exports = {"schedule":{"title":"Program","now_playing":"Most zajlik","empty":{"title":"Nincs találat","detail":"Nincs megjeleníthető közelgő esemény"}}}